import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
	providedIn: 'root'
})
export class TeamsService {
	deleteFailed = 'data delete failed' ; deleteSuccess = 'data delete success' ; insertFailed = 'data insert failed'; dataFails = 'data fails' ; dataSuccess = 'data success'
	contentType = 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15' ; hedr = new HttpHeaders().set('Content-Type', 'application/json'); 
	dataInsertedSuccess = 'data inserted success'
	constructor(private readonly http : HttpClient) { }

	getTeamsList(): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/teams/getTeamsList`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
	}

	getUsersList(teamID): Observable<any> {

		const headers = this.hedr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/teams/getTeamUser`, teamID, { headers, responseType: 'json' })
			.pipe(
				tap(_ => this.log(this.dataInsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	getLPList(teamID): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/teams/getLogisticsPoint/${teamID}`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
	}

	getAMList(): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/teams/getAsstMngr`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
	}


	addTeam(arrData: any): Observable<any> {
		const headers = this.hedr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/teams/addTeams`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log(this.dataInsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	addUser(arrData: any): Observable<any> {
		const headers = this.hedr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/teams/addTeamUser`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log(this.dataInsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	addLP(arrData: any): Observable<any> {
		const headers = this.hedr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/teams/addLogisticsPoint`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log(this.dataInsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}


	deleteTeam(teamid) {
		return this.http
			.delete(`${environment.baseAPIURL}/api/v1/teams/deleteTeam/${teamid}`)
			.pipe(
				tap(_ => this.log(this.deleteSuccess)),
				catchError(this.handleError<any>(this.deleteFailed))
			);
	}

	deleteUser(teamid, networkID) {
		return this.http
			.delete(`${environment.baseAPIURL}/api/v1/teams/deleteTeamUser/${teamid}/${networkID}`)
			.pipe(
				tap(_ => this.log(this.deleteSuccess)),
				catchError(this.handleError<any>(this.deleteFailed))
			);
	}

	deleteLP(teamid, LogisticsPoint) {
		return this.http
			.delete(`${environment.baseAPIURL}/api/v1/teams/deleteTeamLogistics/${teamid}/${LogisticsPoint}`)
			.pipe(
				tap(_ => this.log(this.deleteSuccess)),
				catchError(this.handleError<any>(this.deleteFailed))
			);
	}

	saveLPRow(arrData: any): Observable<any> {
		return this.http
			.put(`${environment.baseAPIURL}/api/v1/teams/updateLogisticsPoint`, arrData)
			.pipe(
				tap(_ => this.log(this.dataInsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	updateAM(arrData: any): Observable<any> {
		return this.http
			.put(`${environment.baseAPIURL}/api/v1/teams/updateAsstMngr`, arrData)
			.pipe(
				tap(_ => this.log(this.dataInsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}



	private handleError<T>(_operation, result?: T) {
		return (error: any): Observable<T> => {
			console.info(error); // log to console instead
			return of(result as T);
		};
	}

	/** Log a message */
	private log(message: string) {
		console.info('Message: ' + message);
	}

}
